<div>

    <div>
        <div *ngFor="let p of store.players" class="d-flex">
            <div>{{p.name}}: {{p.class}} [{{p.level}}]</div>
            <button [disabled]="diving" (click)="AddToDive(p)">ADD</button>
        </div>
    </div>

    <hr>



    <div class="row">
        <div class="col can-compress" [ngClass]="{'compressed': compressed_row}">

            <div class="visual">
                <div *ngFor="let d of dive" class="card mb-2" style="width: 100%">
                    <app-player-block [player]="d.player" [showEquipment]="false"
                        [showAttributes]="true"></app-player-block>
                </div>
            </div>

            <div class="toggle" (click)="toogle_compressed_row()">
                >
            </div>
        </div>
        <div class="col">
            <div>
                Level <input type="number" [(ngModel)]="store.level" [disabled]="diving" style="width:50px" min="1"
                    max="5">, Rooms
                <input type="number" [(ngModel)]="store.rooms" [disabled]="diving" style="width:50px" min="2" max="20">
                <button [disabled]="diving" (click)="Dive()">Dive</button>
                <button [disabled]="diving" (click)="Clear()">Clear</button>
            </div>
            <pre>{{store.output}}</pre>

        </div>

    </div>





</div>